import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enProjectCard from './locales/en/enProjectCard.json';
import nlProjectCard from './locales/nl/nlProjectCard.json';
import enCommon from './locales/en/enCommon.json';
import enDashboard from './locales/en/enDashboard.json';
import nlCommon from './locales/nl/nlCommon.json';
import nlDashboard from './locales/nl/nlDashboard.json';
import enProjectDetails from './locales/en/enProjectDetails.json';
import nlProjectDetails from './locales/nl/nlProjectDetails.json';
import enProjectList from './locales/en/enProjectList.json';
import nlProjectList from './locales/nl/nlProjectList.json';
import enAssets from './locales/en/enAssets.json';
import nlAssets from './locales/nl/nlAssets.json';
import enOwnedAsset from './locales/en/enOwnedAsset.json';
import nlOwnedAsset from './locales/nl/nlOwnedAsset.json';
import enTransactions from './locales/en/enTransactions.json';
import nlTransactions from './locales/nl/nlTransactions.json';
import enProjectListingRootComponent from './locales/en/enProjectListingRootComponent.json';
import nlProjectListingRootComponent from './locales/nl/nlProjectListingRootComponent.json';
import enSidebar from './locales/en/enSidebar.json';
import nlSidebar from './locales/nl/nlSidebar.json';
import enHeader from './locales/en/enHeader.json';
import nlHeader from './locales/nl/nlHeader.json';
import enProfile from './locales/en/enProfile.json';
import nlProfile from './locales/nl/nlProfile.json';
import enPasswordSecurity from './locales/en/enPasswordSecurity.json';
import nlPasswordSecurity from './locales/nl/nlPasswordSecurity.json';
import enAuth from './locales/en/enAuth.json';
import nlAuth from './locales/nl/nlAuth.json';
import enOnfidoKyc from './locales/en/enOnfidoKyc.json';
import nlOnfidoKyc from './locales/nl/nlOnfidoKyc.json';
import enPlatformWalletConnection from './locales/en/enPlatformWalletConnection.json';
import nlPlatformWalletConnection from './locales/nl/nlPlatformWalletConnection.json';
import enProjectAgreement from './locales/en/enProjectAgreement.json';
import nlProjectAgreement from './locales/nl/nlProjectAgreement.json';
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    projectCard: enProjectCard,
    common: enCommon,
    dashboard: enDashboard,
    projectDetails: enProjectDetails,
    projectList: enProjectList,
    assets: enAssets,
    ownedAssets: enOwnedAsset,
    transactions: enTransactions,
    projectListingRootComponent: enProjectListingRootComponent,
    sidebar: enSidebar,
    header: enHeader,
    profile: enProfile,
    passwordSecurity: enPasswordSecurity,
    auth: enAuth,
    onfidoKyc: enOnfidoKyc,
    platformWalletConnection: enPlatformWalletConnection,
    projectAgreement: enProjectAgreement,
  },
  nl: {
    projectCard: nlProjectCard,
    common: nlCommon,
    dashboard: nlDashboard,
    projectDetails: nlProjectDetails,
    projectList: nlProjectList,
    assets: nlAssets,
    ownedAssets: nlOwnedAsset,
    transactions: nlTransactions,
    projectListingRootComponent: nlProjectListingRootComponent,
    sidebar: nlSidebar,
    header: nlHeader,
    profile: nlProfile,
    passwordSecurity: nlPasswordSecurity,
    auth: nlAuth,
    onfidoKyc: nlOnfidoKyc,
    platformWalletConnection: nlPlatformWalletConnection,
    projectAgreement: nlProjectAgreement,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(Backend) // passes i18n down to react-i18next
  .init({
    // lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    // defaultNS: 'en',
    resources,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to your translation files
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    ns: [
      'projectCard',
      'common',
      'dashboard',
      'projectDetails',
      'projectList',
      'assets',
      'ownedAssets',
      'projectListingRootComponent',
      'sidebar',
      'header',
      'profile',
      'passwordSecurity',
      'auth',
      'onfidoKyc',
      'platformWalletConnection',
      'projectAgreement.json',
    ], // Add projectCard to namespaces
    defaultNS: 'common',
  });

export default i18n;
